import _ = require("underscore");
import Portal = require("portal-gis");
import Utils = require("../../utils");
import geo = require("../../utils/geo");
import StringDistance = require("../../utils/levenshtein-distance");
import Base = require("../base-command");

class Command extends Base<{
    out: {
        location: string
    }
}>{

    static about = `
Search text field(s) of a collection.  Field name(s) are identified by the _search-field_ option.
The collection is identified by the _model_ attribute.
`;

    static options = {
        "calculator": {
            "about": "Replacement calculator for determining string distances",
            "default": "app/utils/levenshtein-distance"
        },
        "event": {
            "default": "geoquery-result",
        },
        "model": {
            "about": "mid identifying a _collection_ to search (not a model), uses _mediator.api.features_ by default",
        },
        "panmap": {
            "about": "Pan map to bring results into view",
            "default": "true",
        },
        "search-field": {
            "about": "comma-separated list of fields to search within this collection",
            "default": "text",
        },
        "zoommap": {
            "about": "Zoom map to bring results into full view",
            "default": "true",
        },
    }

    static output = {
        "features": {
            "about": "list of features that were located",
        },
    }
    
    
    // hard-coded to search text field of features, 
    execute(args = this.args) {

        let location = args.out.location;

        let options = _.defaults(this.asOptions(Command.options), {
            model: this.mediator.api.features,
        });

        let fields = Utils.split(options["search-field"]);

        Utils.withModule(StringDistance, options["calculator"], StringDistance => {

            Utils.withModule(this.mediator.api.features, options["model"], source => {

                let data = source.map(s => s.data);
                let results = data.filter(b => fields.some(f => b[f] === location));

                if (!results.length) {
                    let distances = _.flatten(data
                        .map((b, i) => {
                            var c = fields.map(f => new StringDistance(location.toUpperCase(), (b[f] || "").toUpperCase()));
                            c = c.sort((d1, d2) => d1.distance - d2.distance).filter(d => d.distance < 3);
                            return {
                                distances: c,
                                data: b
                            };
                        }));

                    // remove mismatches
                    distances = distances.filter(d => 0 < d.distances.length);
                    // sort by distance
                    data = distances.sort((d1, d2) => d1.distances[0].distance - d2.distances[0].distance).map(d => d.data);
                    // remove duplicates
                    results = _.unique(data);
                }

                if (!results.length) return;

                this.showOnMap(results);

                this.trigger({ features: results });

            });

        });
    }

    private showOnMap(results: Portal.FeatureLeaf[]) {
        let options = this.options;
        // TODO: merge with geoquery-result-handler
        if (options["panmap"] === "true" || options["zoommap"] === "true") {
            this.mediator.mapView(mapView => {
                // TODO: calculate extend of all data items                                      
                let feature = results[0];

                // features
                switch (feature.type) {
                    case "extent":
                        // TODO: pan to center if zoom not desired
                        let extent = geo.asExtent(feature.geom);
                        mapView.extent = extent;
                        break;

                    case "point":
                        let point = JSON.parse(`[${feature.geom}]`);
                        mapView.panTo(point);
                        break;

                    default:
                        if (false) { }
                        // untyped feature?
                        else if (feature.geom) {
                            let point = JSON.parse(`[${feature.geom}]`);
                            mapView.panTo(point);
                        }
                        // bookmark?
                        else if (feature["extent"]) {
                            let extent = geo.asExtent(feature["extent"]);
                            mapView.extent = extent;
                        }
                        break;
                }
            });
        }
    }
}

export = Command;  